import {
  useMutation,
  UseMutationOptions,
  UseQueryOptions,
  useQuery,
} from '@tanstack/react-query';
import apiRoutes from 'services/apiRoutes';
import Axios from './../../apiConfig/Axios';

////////////////////////////////////// forceChangePassword request//////////////////////////

const fetchForceForgetRequestFn = async (
  data: reqForceForgetPasswordRequestType
) => {
  const res = await Axios.post<GlobalApiResponseType<resForceForgetPasswordRequestType>>(
    apiRoutes.forceChangePassword.Request,
    data
  );
  return res.data;
};

export const useForceChangePasswordRequest = (
  data: reqForceForgetPasswordRequestType,
  option?:
    | Omit<
        UseQueryOptions<
          GlobalApiResponseType<resForceForgetPasswordRequestType>,
          Error
        >,
        'mutationKey' | 'mutationFn'
      >
    | undefined
) => {
  return useQuery<
    GlobalApiResponseType<resForceForgetPasswordRequestType>,
    Error
  >(['user-data'], () => fetchForceForgetRequestFn(data), {
    enabled: data.force,
    ...option,
  });
};

////////////////////////////////////// forceChangePassword validation//////////////////////////

const fetchForceChangePasswordValidationFn = async (
  data: reqForceChangePasswordValidationType
) => {
  const res = await Axios.post<GlobalApiResponseType<string>>(
    apiRoutes.forceChangePassword.Validation,
    data
  );
  return res.data;
};

export const useForceChangePasswordValidation = (
  option?: Omit<
    UseMutationOptions<
      GlobalApiResponseType<string>,
      Error,
      reqForceChangePasswordValidationType
    >,
    'mutationKey' | 'mutationFn'
  >
) => {
  return useMutation<
    GlobalApiResponseType<string>,
    Error,
    reqForceChangePasswordValidationType
  >(fetchForceChangePasswordValidationFn, option);
};

////////////////////////////////////// forceChangePassword changePassword//////////////////////////

const fetchForceChangePasswordFn = async (data: reqForceChangePasswordType) => {
  const res = await Axios.post<GlobalApiResponseType<string>>(
    apiRoutes.forceChangePassword.ChangePassword,
    data
  );
  return res.data;
};

export const useForceChangePassword = (
  option?: Omit<
    UseMutationOptions<
      GlobalApiResponseType<string>,
      Error,
      reqForceChangePasswordType
    >,
    'mutationKey' | 'mutationFn'
  >
) => {
  return useMutation<
    GlobalApiResponseType<string>,
    Error,
    reqForceChangePasswordType
  >(fetchForceChangePasswordFn, option);
};
